
import $ from "jquery"

interface Selector {
  scope:  string | Element
  main:   string
}
interface InputSelector {
  scope?:  string | Element
  main?:   string
}
const default_selector = {
  scope:  ".cell-listing-contact-request-box",
  main:   ".cell--listing--contact--request--box__btn-contact-by-spacious",
}

const init = (selector?: InputSelector) => {
  const sele: Selector = Object.assign({}, default_selector, selector)
  const $scope = $(sele.scope)
  const $el = $scope.find(sele.main)

  import(
    "../tracking/index"
  )
  .then(({default: Track_ee}) => {
    $el.on("click", () => Track_ee.emit("submit_click"))
  })
}

export default {init}
